import { usePrivacyMask } from "@nimit9/signet-ui/components/privacy-mask"
import { useMemo } from "react"
import { createCompactCurrencyFormatter, maskedAmountText } from "@/lib/format"
import { useHousehold } from "./use-household"

/** Compact currency formatter (axes, "₹1.2L"); masked like useCurrencyFormat. */
export function useCompactCurrencyFormat(decimals = 1) {
  const { data } = useHousehold()
  const { masked } = usePrivacyMask()
  const currency = data?.household?.currency ?? "INR"
  const locale = data?.household?.locale ?? "en-IN"
  return useMemo(() => {
    if (masked) {
      const text = maskedAmountText(currency, locale)
      return (_amount: number | string): string => text
    }
    return createCompactCurrencyFormatter(currency, locale, decimals)
  }, [currency, locale, decimals, masked])
}
